import CryptoJS from 'crypto-js'

class AESCipher {
  static KEY_LEN = 16;

  // EXACT PHP behavior: pad or truncate
  static normalizeKey(key) {
    key = String(key)

    if (key.length < this.KEY_LEN) {
      return key.padEnd(this.KEY_LEN, '0')
    }

    if (key.length > this.KEY_LEN) {
      return key.substring(0, this.KEY_LEN)
    }

    return key
  }

  static encrypt(key, iv, data) {
    key = this.normalizeKey(key)

    // 🔥 IMPORTANT: Latin1 = closest to PHP raw byte behavior
    const keyBytes = CryptoJS.enc.Latin1.parse(key)
    const ivBytes = CryptoJS.enc.Latin1.parse(iv)
    const dataBytes = CryptoJS.enc.Latin1.parse(data)

    const encrypted = CryptoJS.AES.encrypt(dataBytes, keyBytes, {
      iv: ivBytes,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })

    // RAW output like OPENSSL_RAW_DATA
    const encryptedBase64 = CryptoJS.enc.Base64.stringify(
      encrypted.ciphertext
    )

    const ivBase64 = CryptoJS.enc.Base64.stringify(ivBytes)

    return encodeURIComponent(`${encryptedBase64}:${ivBase64}`)
  }

  static decrypt(key, encryptedData) {
    key = this.normalizeKey(key)

    const decoded = decodeURIComponent(encryptedData)
    const [encryptedBase64, ivBase64] = decoded.split(':')

    const keyBytes = CryptoJS.enc.Latin1.parse(key)
    const ivBytes = CryptoJS.enc.Base64.parse(ivBase64)

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
      keyBytes,
      {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )

    return CryptoJS.enc.Latin1.stringify(decrypted)
  }
}

export default AESCipher
